<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex lg12>
                <p>Please Note: Only .csv (comma seperated values) files are allowed for upload.</p>
                <p>The format and order of the import file must be as follows:</p>
                <p><strong>Company Type (Customer/Specifier)*, Customer Code*, Registration No., VAT No., Name*, Trading Name, Address Line 1*, Address LIne 2, Postal Code, Contact No.*, Fax No., Email, Region Name*.</strong></p>
                <p>Or download the import template <a href="http://myorder.ndtec.co.za/docs/myorder_company_import_template_new.csv" download>here</a></p>
                <p>The first row must be the column headers. Please confirm field validity and cardinality to ensure import integrity.</p>
                <div class="fileHolder">
                    <input type="file" class="fileUpload" @change="fncCheckCsv">
                    <p>Drag & Drop / Click to Add Files</p>
                    <small>{{ fileName }}</small>
                </div>
            </v-flex>
            <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
                <div style="float: right">
                    <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
                    <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
                    <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!uploadValue" @click.stop="fncImportCompanies()">Import</v-btn>
                </div>
            </div>
            <v-flex lg12 class="requiredMessage">
                <small><strong>* The button will activate once all required fields have been completed.</strong></small>
            </v-flex>
        </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'Settings',
        data () {
            return {
                runAdd: false,
                objRows : '',
                fileName: '',
                uploadValue: false
            };
        },
        methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncImportCompanies () {
                this.$store.dispatch('fncImportCompanies', this.objRows)
            },
            fncCheckCsv(e) {
                var files = e.target.files || e.dataTransfer.files;
                var reader = new FileReader();
                var vm = this;
                reader.onload = function(e) {
                    var quoteStatusRows = reader.result;
                    vm.objRows = quoteStatusRows.split("\r\n");
                    vm.fileName = files[0].name;
                }
                reader.readAsText(files[0]);
                this.uploadValue = true;
            }
        },
        computed: {
            ...mapGetters([
                'objAuthorize',
                'globalModalParams',
            ])
        }
    }
</script>

<style scoped>
    /*@import '../../assets/css/shared.css'*/
</style>